import { render, staticRenderFns } from "./ContactNameAndDetails.vue?vue&type=template&id=1ff9a04c"
import script from "./ContactNameAndDetails.vue?vue&type=script&lang=js"
export * from "./ContactNameAndDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactNameAndDetails.vue?vue&type=style&index=0&id=1ff9a04c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports